import Cookies from 'universal-cookie';

export default process.browser ? new Cookies(document.cookie) : new Cookies({});
